import { Box, Header as UCLHeader } from '@rbilabs/universal-components';

import { getDesignToken } from 'styles/constants';
export const Container = Box.withConfig({
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
});

export const Inner = Box.withConfig({
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  padding: '8',
});

export const Header = UCLHeader.withConfig({
  textTransform: getDesignToken('text-transform-headlines'),
  textAlign: 'center',
  marginY: '5',

  maxWidth: {
    base: '3/4',
    md: '500px',
  },
});
